import "./scss/finish.scss";
import { rootReducer } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { CarInfo } from "../types/CarInfo";
import { useHistory } from "react-router-dom";
import Header from "../components/Header";

type AuthState = ReturnType<typeof rootReducer>;
const Finish: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const carInfo = useSelector((state: AuthState) => state.store.carInfo);

  const [carNumber, setCarNumber] = useState<string>("");
  const [parkingDetail, setParkingDetail] = useState<string>("");

  const moveFirst = async () => {
    dispatch({ type: "DRIVER_CLEAR" });
    dispatch({ type: "DRIVER" });
    dispatch({ type: "RESERVATION_ONE" });
    dispatch({ type: "PRODUCT" });
    dispatch({ type: "PRODUCT_RESET" });
    // dispatch({ type: "CARINFO" });

    history.push("/main");
  };

  useEffect(() => {
    console.log("carInfo", carInfo);

    const carNumber = carInfo?.data.carNumber || "";
    const parkingLocationDetail = carInfo?.data.parkingLocationDetail || "";

    setCarNumber(carNumber);
    setParkingDetail(parkingLocationDetail);
  }, []);

  return (
    <>
      <Header></Header>
      <div className="finish-wrap">
        <div className="kiosk-img-wrap">
          <img src="/img/kiosk.svg"></img>
        </div>

        <div className="finish-dec-wrap">
          <h1>이용해주셔서 감사합니다.</h1>
          <span>
            데스크에 인수증을 보여주세요.
            <br />
            작성하신 계약서는 주 운전자에게 SMS 발송됩니다.
            <br /> 기타 궁금한 사항은 데스크로 문의바랍니다.
          </span>
        </div>

        <div className="finish-car-wrap">
          <div className="info" style={{ borderRight: "1px solid #5C6373" }}>
            <span className="area">배차구역</span>
            <span className="location">{parkingDetail}</span>
          </div>

          <div className="info">
            <span className="area">차량번호</span>
            <span className="location">{carNumber}</span>
          </div>
        </div>
        <div className="btn-wrap" style={{ width: "100%" }}>
          <button
            onClick={() => {
              moveFirst();
            }}
          >
            처음으로
          </button>
        </div>
      </div>
    </>
  );
};

export default Finish;
